import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import { Content } from "./Content";
import { getUserAccessLevelByRoleName, getUserAccessLevel  } from '../../../../app/helpers/role';
import { getUser } from '../../../../index';
import api from '../../../../app/services/api';
import { isMobile } from "react-device-detect";

/**
 * @typedef ContentRouteProps
 * @property {} children 
 * @property {} component 
 * @property {} render 
 * @property {('colaborador'|'usuario'|'supervisor'|'cordenador'|'gestor'|'admin'|'superadmin'|'impossible')} roleLevel 
 *//**
 * 
 * @param {ContentRouteProps} param0 
 * @returns 
 */
export function ContentRoute({ children, component, render, roleLevel, ...props }) {

    const user = getUser();
    
    const roleLevelUser = getUserAccessLevel();
    const roleLevelRoute = getUserAccessLevelByRoleName(roleLevel);
   
    api.post(`/ux_analytics`, {
        userId: user.id,
        Application: "Biblioteca",
        EventUx: "Access",
        Action: "Access",
        Platform: isMobile ? "Mobile" : "Desktop",
        Menu: props.path.substring(1)
    })
    return (
        <Route {...props}>
            {routeProps => {

                if (roleLevelRoute > roleLevelUser) {
                    return <Redirect to="/not-authorized" />;
                }

                if (typeof children === "function") {
                    return <Content>{children(routeProps)}</Content>;
                }

                if (!routeProps.match) {
                    return null;
                }

                if (children) {
                    return <Content>{children}</Content>;
                }

                if (component) {
                    return (
                        <Content>{React.createElement(component, routeProps)}</Content>
                    );
                }

                if (render) {
                    return <Content>{render(routeProps)}</Content>;
                }

                return null;
            }}
        </Route>
    );
}
